import useAuth from '@byma/shared/hooks/useAuth'
import MoneyInput from '@byma/shared/components/MoneyInput'
import EventSelector from 'components/EventSelector'
import { useRouter } from 'next/router'
import useToastContext from "@byma/shared/hooks/useToastContext";
import useSWR, { useSWRConfig } from 'swr'
import dayjs from 'dayjs'
import fetcher from '@byma/shared/helpers/fetcher'
import Loader from '@byma/shared/components/Loader'
import Input from '@byma/shared/components/Input'
import { useState } from 'react'
import useFilters from '@byma/shared/hooks/useFilters'

export default function NewWithdrawal({ disabled, availableCents }) {
    const session = useAuth()
    const { token, user: currentUser } = session
    const [newWithdrawalOpen, setNewWithdrawalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const addToast = useToastContext()
    const { query, ...router } = useRouter()
    const { mutate } = useSWRConfig()
    const { queryString } = useFilters({...query, d:'all'})
    const [selectedEvent, setSelectedEvent] = useState(null)
    //const { data: parties, error } = useSWR(token ? [`/api/parties/getAll?search=${searchQuery}&perPage=20`, null, token] : null, fetcher)
    //

    async function handleSave(e) {
        e.preventDefault()

        if (!selectedEvent) {
            return addToast('Selecione um evento primeiro', 'error')
        }

        setIsLoading(true)
        const body = {
            partyId: selectedEvent._id,
            description: e.currentTarget.description.value,
            amountCents: Math.round(parseFloat(e.currentTarget.amountCents.value.replace(/\./g, '').replace(/,/, '.')) * 100),
            pixKey: e.currentTarget.pixKey.value,
            pixKeyType: e.currentTarget.pixKeyType.value,
            pixKeyHolderName: e.currentTarget.pixKeyHolderName.value,

        }

        if (body.amountCents > availableCents) {
            setIsLoading(false)
            return addToast('Saldo insuficiente', 'error')
        }

        try {
            const res = await fetch('/api/withdrawals/create', {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'Auth': token
                },
                body: JSON.stringify(body),
            })
            if (res.status === 200) {
                setNewWithdrawalOpen(false)
                addToast('Saque cadastrado com sucesso')
                mutate([`/api/payments/report?${queryString}`, null, token])
                mutate([`/api/invoiceitems/getAll?${queryString}`, null, token])
                mutate([`/api/receivables/getAll?${queryString}`, null, token])
                mutate([`/api/anticipations/getAll?${queryString}`, null, token])
                mutate([`/api/withdrawals/getAll?${queryString}`, null, token])
                mutate([`/api/withdrawals/getAll?status=requested&limit=30`, null, token])
                setIsLoading(false)
            } else {
                throw new Error(await res.json())
            }
        } catch (error) {
            setIsLoading(false)
            addToast('Erro ao cadastrar saque', 'error')
            console.error('An unexpected error happened occurred:', error)
        }
    }

    return (
        <div className="">
            <button className="flex justify-between items-center space-x-1 cursor-pointer rounded shadow px-2 py-1 text-sm hover:shadow-md whitespace-nowrap focus:shadow-sm" onClick={() => !disabled && setNewWithdrawalOpen(!newWithdrawalOpen)}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
                </svg>
                <p>Novo saque</p>
            </button>
            <div className={`fixed w-full h-full inset-0 transition-opacity duration-100 ${newWithdrawalOpen ? 'z-50 opacity-100' : '-z-1 opacity-0'}`} onClick={() => setNewWithdrawalOpen(false)}>
                <div class="absolute w-full h-full bg-gray-900 opacity-50" />
                <div class="modal-content absolute bg-white w-full md:w-11/12 md:max-w-md md:mx-auto md:rounded md:shadow-lg z-50 md:h-min" onClick={(e) => e.stopPropagation()}>
                    <div className="flex flex-col justify-between p-3 space-y-3 h-full overflow-y-auto">
                        <div className="">
                            <div className="flex justify-between items-center mb-3">
                                <div className="">
                                    <p className="font-bold text-xl">Novo saque</p>
                                </div>
                                <div className="cursor-pointer" onClick={() => setNewWithdrawalOpen(false)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                                    </svg>
                                </div>
                            </div>
                            <EventSelector selectedEvent={selectedEvent} onChange={setSelectedEvent} />
                            <form onSubmit={handleSave} className="flex flex-col space-y-3">
                                <Input name="description" type="text" label="Observações" required size="s" />
                                <div className="flex space-x-3">
                                    <MoneyInput name="amountCents" label="Valor" step="0.01" required size="s" />
                                </div>
                                <div className="grid grid-cols-3 gap-3">
                                    <div className="col-span-2">
                                        <Input 
                                            size="s"
                                            type="text" 
                                            label='Chave PIX' 
                                            name="pixKey"
                                        />
                                    </div>
                                    <div className="w-full">
                                        <select
                                            placeholder="Tipo de chave"
                                            className={`p-2 h-min w-full`}
                                            name="pixKeyType"
                                        >
                                            <option value="">Tipo de chave</option>
                                            <option value="CPF">CPF</option>
                                            <option value="CNPJ">CNPJ</option>
                                            <option value="EMAIL">Email</option>
                                            <option value="PHONE">Telefone</option>
                                            <option value="RANDOM">Aleatória</option>
                                        </select>
                                    </div>
                                    <div className="col-span-3">
                                        <Input 
                                            size="s"
                                            type="text" 
                                            label='Titular da Chave PIX' 
                                            name="pixKeyHolderName"
                                        />
                                    </div>
                                </div>
                                <div className="">
                                    {isLoading ? <Loader /> : (
                                        <button type="submit" className="btn btn-primary w-full">Solicitar saque</button>
                                    )}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}
